import {useState} from 'react';
import styled from 'styled-components';
import {GlobalNormalize} from '../../tokens/normalize';
import {GlobalFonts} from '../../tokens/fonts';
import {GlobalColors} from '../../tokens/colors';
import {GlobalRadiuses} from '../../tokens/radiuses';
import {GlobalTransitions} from '../../tokens/transitions';
import {GlobalShadows} from '../../tokens/shadows';
import {OrderForm} from '../order-form/order-form';
import {OrderItem} from '../order-item/order-item';
import {SaveOrderModal} from '../save-order-modal/save-order-modal';
import {InitializeParamsContext} from '../../store/context/context';

const Wrapper = styled.div`
    overflow: hidden;
`;

const Header = styled.div`
    text-align: center;
    margin: 60px 0 30px;
`;

const HeaderTitle = styled.div`
    font-weight: 600;
    font-size: 18px;
    line-height: 25px;
    color: black;
    margin-bottom: 10px;
`;

const HeaderBody = styled.div`
    font-size: 14px;
    line-height: 19px;
    opacity: 0.6;
    color: black;
`;

const ProductionOrder = ({orderId, infoText, userAuth}) => {
    const [order, setOrder] = useState([]);
    const [hideForm, setHideForm] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [orderNumber, setOrderNumber] = useState();
    const [userName, setUserName] = useState('');

    return (
        <InitializeParamsContext.Provider
            value={{
                userName,
                orderId,
                infoText,
                userAuth,
            }}
        >
            <GlobalNormalize />
            <GlobalFonts />
            <GlobalColors />
            <GlobalRadiuses />
            <GlobalTransitions />
            <GlobalShadows />
            <Wrapper>
                {showModal && (
                    <SaveOrderModal isOpen={showModal} taskNumber={orderNumber} onClose={() => setShowModal(false)} />
                )}
                {!hideForm && (
                    <Header>
                        <HeaderTitle>Отслеживание заказа производственного цеха</HeaderTitle>
                        <HeaderBody>
                            Укажите номер производственного задания, 6 последних цифр. Например, 100898.
                        </HeaderBody>
                    </Header>
                )}
                {!hideForm && (
                    <OrderForm
                        onFindOrder={setOrder}
                        setHideForm={setHideForm}
                        setShowModal={setShowModal}
                        setOrderNumber={setOrderNumber}
                        setUserName={setUserName}
                    />
                )}
                {hideForm && <OrderItem order={order} />}
            </Wrapper>
        </InitializeParamsContext.Provider>
    );
};

export {ProductionOrder};
